import { injectIntl } from 'react-intl';

import SMButton from './ServiceMapButton';

export default injectIntl(SMButton);
